<div class="electrip-form">
    <h2>Add New Citizen Type</h2>
    <form [formGroup]="citizenTypeForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="fill">
            <mat-label>Name</mat-label>
            <input matInput required formControlName="name">
        </mat-form-field>
        <button type="submit" mat-button primary [disabled]="!citizenTypeForm.valid">Submit</button>
    </form>
</div>